"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay, Mousewheel, Navigation } from "swiper/modules";
import { ChevronLeft, ChevronRight } from "lucide-react";
import Link from "next/link";
import MaxWidthContainer from "./max-width-container";
import { api } from "@/trpc/react";
import { Skeleton } from "../ui/skeleton";
import { cloudFrontUrl, cn } from "@/lib/utils";
import Image from "next/image";

const OfferBannerSlider = ({ isTripPage, className }: { isTripPage?: boolean, className?: string }) => {
  const { data, isLoading } = api.banner.getOfferBanners.useQuery();

  if (isLoading)
    return (
      isTripPage ? (
        <section className="relative rounded-xl overflow-hidden border-t-[6px] border-t-custom-secondary">
          <Skeleton className="relative h-24 w-full sm:h-40 lg:h-24 xl:h-[7.25rem] bg-gray-100" />
        </section>
      ) : (
        <section className="py-6 sm:py-8 md:py-10 lg:py-16 mt-10">
          <MaxWidthContainer>
            <Skeleton className="h-24 rounded-xl bg-gray-300 sm:h-40 lg:h-64 xl:h-80" />
          </MaxWidthContainer>
        </section>
      )
    );

  if (!data || data.length === 0) return null;

  if (isTripPage) return (
    <div className="relative rounded-xl overflow-hidden border-t-[6px] border-t-custom-secondary">
      <Swiper
        navigation={{
          prevEl: `.offerBannerPrev`,
          nextEl: `.offerBannerNext`,
        }}
        autoplay={{
          pauseOnMouseEnter: true,
          delay: 3333,
        }}
        slidesPerView={1}
        spaceBetween={16}
        loop={true}
        mousewheel={{
          forceToAxis: true,
          invert: false,
        }}
        modules={[Navigation, Autoplay, Mousewheel]}
        className="mySwiper"
      >
        {data.map((data) => (
          <SwiperSlide key={data.id}>
            <Link target="_blank" href={data.link}>
              <div className="relative h-24 w-full sm:h-40 lg:h-24 xl:h-[7.25rem] bg-gray-100">
                <Image
                  src={cloudFrontUrl(data.image_url)}
                  alt={"trek karo india offers"}
                  fill
                  className="object-cover"
                />
              </div>
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );

  return (
    <section className={cn("py-8 md:py-10 lg:py-12", className)}>
      <MaxWidthContainer>
        <div className="relative">
          <Swiper
            navigation={{
              prevEl: `.offerBannerPrev`,
              nextEl: `.offerBannerNext`,
            }}
            autoplay={{
              pauseOnMouseEnter: true,
              delay: 3333,
            }}
            slidesPerView={1}
            spaceBetween={16}
            loop={true}
            mousewheel={{
              forceToAxis: true,
              invert: false,
            }}
            modules={[Navigation, Autoplay, Mousewheel]}
            className="mySwiper"
          >
            {data.map((data) => (
              <SwiperSlide key={data.id}>
                <Link target="_blank" href={data.link}>
                  <div className="relative h-24 w-full overflow-hidden rounded-md sm:rounded-lg lg:rounded-xl sm:h-40 lg:h-64 xl:h-80 bg-gray-100">
                    <Image
                      src={cloudFrontUrl(data.image_url)}
                      alt={"trek karo india offers"}
                      fill
                      className="object-cover"
                    />
                  </div>
                </Link>
              </SwiperSlide>
            ))}
          </Swiper>
          <button className="offerBannerPrev absolute left-4 top-1/2 z-10 hidden h-6 w-6 -translate-y-1/2 rounded-full bg-white p-0.5 text-custom-primary shadow-[0px_2px_8px_0px_rgba(0,0,0,0.25)] transition-all duration-300 ease-in-out hover:bg-custom-primary hover:text-white hover:shadow-none disabled:cursor-not-allowed disabled:hover:bg-white disabled:hover:text-custom-primary disabled:hover:shadow-[0px_2px_8px_0px_rgba(0,0,0,0.25)] md:h-7 md:w-7 lg:h-8 lg:w-8 lg:p-1">
            <ChevronLeft className="-ml-0.5 h-full w-full" strokeWidth={1.5} />
          </button>
          <button className="offerBannerNext absolute right-4 top-1/2 z-10 hidden h-6 w-6 -translate-y-1/2 rounded-full bg-white p-0.5 text-custom-primary shadow-[0px_2px_8px_0px_rgba(0,0,0,0.25)] transition-all duration-300 ease-in-out hover:bg-custom-primary hover:text-white hover:shadow-none disabled:cursor-not-allowed disabled:hover:bg-white disabled:hover:text-custom-primary disabled:hover:shadow-[0px_2px_8px_0px_rgba(0,0,0,0.25)] md:h-7 md:w-7 lg:h-8 lg:w-8 lg:p-1">
            <ChevronRight className="-mr-0.5 h-full w-full" strokeWidth={1.5} />
          </button>
        </div>
      </MaxWidthContainer>
    </section>
  );
};

export default OfferBannerSlider;
